import { render } from "./SubscribeView.vue?vue&type=template&id=827f7bc6&scoped=true"
import script from "./SubscribeView.vue?vue&type=script&lang=js"
export * from "./SubscribeView.vue?vue&type=script&lang=js"

import "./SubscribeView.vue?vue&type=style&index=0&id=827f7bc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-827f7bc6"]])

export default __exports__